module.exports = __webpack_public_path__ + "media/images/redrock/hero-image-corona-raw-dd903ad57fcdf1ae0c9a0fb369c309ee.jpeg";